{
  "nl": {
    "qrcodes": {
      "buttons": {
        "generate": "QR-Code genereren"
      }
    }
  }
}
